module.exports = __webpack_public_path__ + "img/avatar_dummy_profile.b395ab03.svg";